var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center class_Grupo my-4"},[_c('span',{attrs:{"my-10":""}},[_vm._v(_vm._s(_vm.titulo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }